import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import styles from './Navbar.module.css';

const AffiliateNavbar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('affiliateToken');
    navigate('/affiliate/login');
  };

  return (
    <nav className={`${styles.navbar} ${styles.scrolled}`}>
      <div className={styles.navInner}>
        <Link to="/affiliate/dashboard" className={styles.logo}>
          OFMIG<span>.SHOP</span>
        </Link>

        <div className={styles.navRight}>
          <button 
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.5rem 1rem',
              background: 'var(--bg-surface)',
              color: 'var(--text-secondary)',
              border: '1px solid var(--border)',
              borderRadius: 'var(--r-sm)',
              fontSize: '0.875rem',
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'all var(--duration-base) var(--ease)',
              fontFamily: 'var(--font-sans)',
            }}
          >
            <FiLogOut size={14} /> Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AffiliateNavbar;
